





import { Component, Prop } from "vue-property-decorator";
import DataTable from "@/shared/components/data-table.vue";
import GlobalMixin from "@/shared/mixins/globalMixin";
import { mixins } from "vue-class-component";
import PlanosAba from "../tables/PlanosAba.vue";
import Atendimentos from "../tables/Atendimentos.vue";

@Component({
  components: {
    DataTable,
    PlanosAba,
    Atendimentos,
  },
})
export default class TabAtendimento extends mixins(GlobalMixin) {
  @Prop() idConsultor!: number;
}
